import React from 'react';

import { useTranslator } from '../../../../../components/i18n/useTranslator';
import { updateTag } from '../../../../../element/tags/tagsService';
import { getElementId, getTitle } from '../../../../../../common/elements/utils/elementPropertyUtils';

import Icon from '../../../../../components/icons/Icon';

import { TagsToolbarPopupProps } from './popup/TagsToolbarPopup';

const TagMoveButtons: React.FC<TagsToolbarPopupProps> = ({ tag, shareRootPath, closePopup }) => {
    if (!tag || !shareRootPath) return null;

    const translate = useTranslator('popup', 'tags.edit');
    const tagRootId = tag.rootBoardIds[0];

    const handleMoveTag = (newRootBoardId: string) => {
        updateTag(tag._id, { rootBoardIds: [newRootBoardId] });
        closePopup();
    };

    return (
        <ul className="TagsMoveButtons mt-2">
            {shareRootPath.map((element, index) => {
                const id = getElementId(element);
                const title = getTitle(element);

                return (
                    <li
                        key={id}
                        className="flex flex-row cursor-pointer"
                        onClick={() => handleMoveTag(id)}
                        style={{ marginLeft: `${index * 2}rem` }}
                    >
                        {id === tagRootId ? <Icon name="green-tick" /> : <span className="font-bold">&rarr;</span>}

                        <span className={`text-left text-sm ml-1 ${id === tagRootId ? 'text-gray-400' : ''}`}>
                            {id === tagRootId ? translate('in') : translate('moveTo')}
                            {'\u00A0'}
                            <span className="font-bold">{title}</span>
                        </span>
                    </li>
                );
            })}
        </ul>
    );
};

export default TagMoveButtons;
